import styled from "styled-components";
import { Colors } from "../../../../values/colors";

export const PanelContainer = styled.div`
  position: absolute;
  top: 0;
  ${({ $align }) =>
    $align === "left"
      ? "right: calc(100% + 8px);"
      : "left: calc(100% + 8px);"}
  width: 300px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid ${Colors.ultraLightGray};
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 1;
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid ${Colors.ultraLightGray2};
`;

export const PanelTitle = styled.h3`
  font-weight: 700;
  font-size: 15px;
  color: ${Colors.blueGray2};
  margin: 0;
`;

export const PanelBody = styled.div`
  padding: 14px 16px;
`;

export const OptionsBody = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RadioOption = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  border: 1.5px solid ${({ selected }) => (selected ? Colors.primaryPurple : Colors.ultraLightGray)};
  background: ${({ selected }) => (selected ? "rgba(93, 61, 237, 0.04)" : "#fff")};
  cursor: pointer;
  margin-bottom: 8px;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: ${({ selected }) => (selected ? Colors.primaryPurple : Colors.lightGray)};
    background: ${({ selected }) =>
      selected ? "rgba(93, 61, 237, 0.04)" : Colors.ultraLightGray3};
  }
`;

export const RadioCircle = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid ${({ selected }) => (selected ? Colors.primaryPurple : Colors.lightGray)};
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.15s;

  &::after {
    content: "";
    display: ${({ selected }) => (selected ? "block" : "none")};
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${Colors.primaryPurple};
  }
`;

export const OptionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const OptionTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${Colors.blueGray};
`;

export const OptionDesc = styled.span`
  font-size: 11px;
  color: ${Colors.blueMist};
`;

export const CategoriesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: -8px 0 10px;
  padding: 12px;
  border: 1.5px solid ${Colors.primaryPurple};
  border-top: none;
  border-radius: 0 0 8px 8px;
  background: rgba(93, 61, 237, 0.04);
`;

export const CategoriesLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: ${Colors.blueMist};
  margin-bottom: 2px;
`;

export const CheckboxOption = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 2px 0;
  user-select: none;

  &:hover {
    opacity: 0.75;
  }
`;

export const CheckboxBox = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 3px;
  border: 2px solid ${({ checked }) => (checked ? Colors.primaryPurple : Colors.lightGray)};
  background: ${({ checked }) => (checked ? Colors.primaryPurple : "#fff")};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
`;

export const CheckMark = styled.div`
  width: 7px;
  height: 4px;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg) translateY(-1px);
`;

export const DownloadBtn = styled.button`
  width: 100%;
  padding: 11px;
  border-radius: 8px;
  border: none;
  background: ${({ disabled }) => (disabled ? Colors.ultraLightGray : Colors.primaryPurple)};
  color: ${({ disabled }) => (disabled ? Colors.lightGray : "#fff")};
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  margin-top: 10px;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.88;
  }
`;

export const SuccessWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 8px 8px;
  gap: 12px;
`;

export const SuccessIconWrap = styled.div`
  margin-bottom: 4px;
`;

export const SuccessTitle = styled.h3`
  font-size: 17px;
  font-weight: 700;
  color: ${Colors.primaryColor};
  margin: 0;
`;

export const SuccessSubtext = styled.p`
  font-size: 12px;
  color: ${Colors.blueMist};
  margin: 0;
  line-height: 1.6;
`;
